import { IHttpClient } from '../../models/http-client/HttpClient.interface'
import { HttpClientHelper } from '@/helpers/HttpClient.helper'
import { carbonZeroWidgetConfigs } from '@/configs'

// export instance of HttpClientModel
export const HttpClient: IHttpClient = new HttpClientHelper(carbonZeroWidgetConfigs())
